export default {"src":"/_next/static/media/Nationwide-network-green.b06c2e5d.svg","height":1600,"width":1600};